/**
 *
 * Project settings - override any values from platform settingsDefaults here
 *
 */

import settingsDefault from '_platform/src/theme/settingsDefault';

const settings = {
  // -- Base Settings --
  siteName: 'RSR Rewards ',

  // -- Cloudinary Settings --
  // Cloudinary cloud name
  cloudinaryCloudName: 'incremental',

  // -- Rewards --
  // Hide reward category images (main rewards page)
  // rewardsCategoryHideImage: true,

  // Pages - must have trailing slash
  cartPage: '/cart/',
  privacyPage: '/privacy/',
  rewardsPage: '/shop/',

  mobileAppSSOEnabled: true,

  // Delivery method "Client" label (usually Branch or Rep)
  deliveryMethodClientLabel: 'Branch',

  // Master override settings
  // cartDisabled: true,
  // quickviewDisabled: true,
  // wishlistDisabled: true,

  // -- Default Overrides --

  // Important!: If the user is being redirected, ensure that the PrivateRoute
  // component has the `tempAuthAllowed` prop set, otherwise the user will not
  // be able to see/update their profile.
  // For futher documentation, see _platform/src/theme/settingsDefault.js
  // redirectOnIncompleteProfile: '/profile/',

  // Rewards page - disable category listing and display rewards on the main page
  // rewardsCategorySkip: true,

  // Google Maps JavaScript API URL
  // Instructions: https://developers.google.com/maps/documentation/javascript/get-api-key
  // Create the project and generate the Maps Javascript API key in
  // https://console.cloud.google.com/google/maps-apis/apis/places-backend.googleapis.com/
  // Make sure the following APIs are enabled:
  // - Maps JavaScript API
  // - Places API
  // - Geocoding API
  // Make sure to restrict the API Key to prevent unauthorised use - Restrict to used services.
  // googleMapsLibraryPath: 'https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places',
  googleMapsLibraryPath:
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCW9NKdjpGllmJ-b6R0zWo1MCB5qRUaDYg&libraries=places',

  // Minimum password character length
  minimumPasswordLength: 8,
  passwordRequirementMessage:
    'Passwords must be at least 8 characters long and must contain at least 1 digit and 1 lowercase letter.',
};

// Note: If you are altering the breakpoints, make sure you loop over the
// values and create the media prop. See settingsDefault.js for implementation.

// Deep merge with default values
const settingsApp = { ...settingsDefault, ...settings };

export default settingsApp;
